// import { ArtistCard } from '@components/Cards/ArtistCard/ArtistCard';
// import { ArtistGrid } from '@components/Grids/Artist/ArtistGrid';
// import { useMediaQuery } from '@hooks/useMediaQuery';
// import { useGetProfilesInfinityList } from '@services/social/hooks/useGetProfiles';
// import { PageQueries } from '@specs/navigation';
// import { useRouter } from 'next/router';
// import React, { FC, useRef } from 'react';

// type ArtistsListProps = {
// }

// export const ArtistsList: FC<ArtistsListProps> = ({ }) => {
//     const enabledRef = useRef(false)
//     const router = useRouter()

//     const isMobile = useMediaQuery('(max-width: 767.98px)')

//     const { query }: PageQueries = router.query
//     const {
//         data,
//         fetchNextPage,
//         hasNextPage,
//         isFetchingNextPage,
//         status,
//     } = useGetProfilesInfinityList({ limit: isMobile ? 4 : 9, query, filter: { artists: true, popular: query ? undefined : false } })

//     const fetchNext = async () => { await fetchNextPage() }
//     return (
//         <div>
//             <ArtistGrid
//                 data={data}
//                 enabledRef={enabledRef}
//                 isFetchingNextPage={isFetchingNextPage}
//                 hasNextPage={hasNextPage}
//                 fetchNext={fetchNext}
//                 status={status}
//                 limit={9}
//                 showBanners={query ? false : true}
//                 listClassName='_artistsGrid'
//             >
//                 {(item) => {
//                     return (
//                         <ArtistCard data={item} />
//                     )
//                 }}
//             </ArtistGrid>
//         </div>
//     );
// };

import { ArtistCard } from '@components/Cards/ArtistCard/ArtistCard';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { useGetProfiles } from '@services/social/hooks/useGetProfiles';
import { PageQueries } from '@specs/navigation';
import { useRouter } from 'next/router';
import React, { FC, useEffect, useRef, useState } from 'react';
import { PaginatedArtistGrid } from '@components/Grids/Artist/PaginatedArtistGrid';
type ArtistsListProps = {};
export const ArtistsList: FC<ArtistsListProps> = () => {
  const router = useRouter();
  const isMobile = useMediaQuery('(max-width: 767.98px)');
  const [shouldScroll, setShouldScroll] = useState(false);
  const gridRef = useRef<HTMLDivElement>(null);
  const limit = isMobile ? 4 : 12;
  const {
    query,
    page = '1'
  }: PageQueries = router.query;
  const currentPage = Number(page);
  const {
    data,
    status
  } = useGetProfiles({
    limit,
    skip: (currentPage - 1) * limit,
    query,
    filter: {
      artists: true,
      popular: query ? undefined : false
    }
  });
  const handlePageChange = (newPage: number) => {
    router.push({
      query: {
        ...router.query,
        page: newPage.toString()
      }
    }, undefined, {
      scroll: false
    });
    setShouldScroll(true);
  };
  useEffect(() => {
    if (shouldScroll && status === 'success' && data?.items.length) {
      if (gridRef.current) {
        window.scrollTo({
          top: gridRef.current.offsetTop - 100,
          behavior: 'smooth'
        });
      }
      setShouldScroll(false);
    }
  }, [status, shouldScroll, data]);
  return <div ref={gridRef} data-sentry-component="ArtistsList" data-sentry-source-file="ArtistsList.tsx">
            <PaginatedArtistGrid data={data} currentPage={currentPage} onPageChange={handlePageChange} status={status} limit={limit} showBanners={!query} listClassName='_artistsGrid' data-sentry-element="PaginatedArtistGrid" data-sentry-source-file="ArtistsList.tsx">
                {item => <ArtistCard key={item.id} data={item} />}
            </PaginatedArtistGrid>
        </div>;
};